<template lang='pug' src='./home.pug'></template>

<script>
import About from 'components/sections/about-us/about-us'
import Contact from 'components/sections/contact/contact'
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'
import Modal from 'components/modal/modal'
import Navigation from 'components/navigation/navigation'
import OfficeModal from 'components/modal/office-modal/office-modal'
import Testimonials from 'components/sections/testimonials/testimonials'
import Treatments from 'components/sections/treatments/treatments'
import Welcome from 'components/sections/welcome/welcome'
import Why from 'components/sections/why/why'

export default {
  name: 'home',
  data () {
    return {
      index: 0,
      pageNum: 0,
      opts: {
        start: 0,
        dir: 'v',
        beforeChange: (prev, next) => {
          this.index = next
        },
        afterChange: (prev, next) => {
          const welcome = document.getElementsByClassName('welcome')[0]
          const about = document.getElementsByClassName('about-us')[0]
          const testimonials = document.getElementsByClassName('testimonials')[0]
          const why = document.getElementsByClassName('why')[0]
          const treatments = document.getElementsByClassName('treatments')[0]
          const contact = document.getElementsByClassName('contact')[0]
          // Hero
          if (next === 0) {
            this.$store.dispatch('VIEW_COLOR', false)
            welcome.classList.remove('welcome--active')
            about.classList.remove('about-us--active')
            testimonials.classList.remove('testimonials--active')
            treatments.classList.remove('treatments--active')
            contact.classList.remove('contact--active')
            why.classList.remove('why--active')
          }
          // Welcome
          if (next === 1) {
            this.$store.dispatch('VIEW_COLOR', false)
            welcome.classList.add('welcome--active')
            about.classList.remove('about-us--active')
            testimonials.classList.remove('testimonials--active')
            treatments.classList.remove('treatments--active')
            contact.classList.remove('contact--active')
            why.classList.remove('why--active')
          }
          // About
          if (next === 2) {
            this.$store.dispatch('VIEW_COLOR', true)
            about.classList.add('about-us--active')
            welcome.classList.remove('welcome--active')
            testimonials.classList.remove('testimonials--active')
            treatments.classList.remove('treatments--active')
            contact.classList.remove('contact--active')
            why.classList.remove('why--active')
          }
          // Testimonials
          if (next === 3) {
            this.$store.dispatch('VIEW_COLOR', false)
            testimonials.classList.add('testimonials--active')
            welcome.classList.remove('welcome--active')
            about.classList.remove('about-us--active')
            why.classList.remove('why--active')
            treatments.classList.remove('treatments--active')
            contact.classList.remove('contact--active')
          }
          // Why
          if (next === 4) {
            this.$store.dispatch('VIEW_COLOR', false)
            why.classList.add('why--active')
            testimonials.classList.remove('testimonials--active')
            welcome.classList.remove('welcome--active')
            about.classList.remove('about-us--active')
            treatments.classList.remove('treatments--active')
            contact.classList.remove('contact--active')
          }
          // Treatments
          if (next === 5) {
            this.$store.dispatch('VIEW_COLOR', true)
            treatments.classList.add('treatments--active')
            why.classList.remove('why--active')
            testimonials.classList.remove('testimonials--active')
            welcome.classList.remove('welcome--active')
            about.classList.remove('about-us--active')
            contact.classList.remove('contact--active')
          }

          // Contact
          if (next === 6) {
            this.$store.dispatch('VIEW_COLOR', false)
            contact.classList.add('contact--active')
            treatments.classList.remove('treatments--active')
            why.classList.remove('why--active')
            testimonials.classList.remove('testimonials--active')
            welcome.classList.remove('welcome--active')
            about.classList.remove('about-us--active')
          }
        }
      }
    }
  },
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    About,
    Contact,
    Hero,
    Loader,
    Modal,
    Navigation,
    OfficeModal,
    Testimonials,
    Treatments,
    Welcome,
    Why
  },
  methods: {
    moveTo (i) {
      this.$refs.home.$fullpage.moveTo(i, true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?98e2fc5e